import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenListDirectionByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDirectionByLocationController.php
* @route '/api/screen/data/get-list-direction-by-location'
*/
const GetScreenListDirectionByLocationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenListDirectionByLocationController.url(options),
    method: 'get',
})

GetScreenListDirectionByLocationController.definition = {
    methods: ["get","head"],
    url: '/api/screen/data/get-list-direction-by-location',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenListDirectionByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDirectionByLocationController.php
* @route '/api/screen/data/get-list-direction-by-location'
*/
GetScreenListDirectionByLocationController.url = (options?: RouteQueryOptions) => {
    return GetScreenListDirectionByLocationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenListDirectionByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDirectionByLocationController.php
* @route '/api/screen/data/get-list-direction-by-location'
*/
GetScreenListDirectionByLocationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenListDirectionByLocationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenListDirectionByLocationController::__invoke
* @see app/Http/Controllers/Screen/GetScreenListDirectionByLocationController.php
* @route '/api/screen/data/get-list-direction-by-location'
*/
GetScreenListDirectionByLocationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenListDirectionByLocationController.url(options),
    method: 'head',
})

export default GetScreenListDirectionByLocationController